import { HeaderNavigationModel } from '@/types';
import classNames from 'classnames';
import Link from '../general/Link';
import { usePathname } from 'next/navigation';

type DesktopNavModel = {
  links: HeaderNavigationModel[];
} & React.HTMLAttributes<HTMLDivElement>;

const DesktopNav = ({ links, className, ...props }: DesktopNavModel) => {
  const pathname = usePathname();
  return (
    <div
      className={classNames(
        className,
        'gap-1 rounded-full bg-transparent transition-colors duration-500 group-[.transparent-bg]:border-[#808080] group-[.transparent-bg]:bg-[#808080bd]',
      )}
      {...props}
    >
      {links.map((link, index) => {
        const className = classNames(
          'btn cursor-pointer !text-sm !px-5 !py-[12px] !font-normal text-black group-[.transparent-bg]:text-white',
          'hover:bg-black hover:text-white group-[.transparent-bg]:hover:bg-white group-[.transparent-bg]:hover:text-black',
          pathname === link.props.link?.href && 'bg-[#e9e3e3] group-[.transparent-bg]:bg-black',
        );

        return link.props.link ? (
          <Link link={link.props.link} key={index} className={className}>
            {link.props.label}
          </Link>
        ) : (
          <div key={index} className={className}>
            {link.props.label}
          </div>
        );
      })}
    </div>
  );
};

export default DesktopNav;
